import React, { useState } from "react";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { setUserId } from "../../services/service";

const Register = ({ navigation }) => {
  const navigate = useNavigate();
  const auth = getAuth();
  const [email, setEmail] = useState("test@hotmail.com");
  const [password, setPassword] = useState("Azerty123");
  const [confirmPassword, setConfirmPassword] = useState("Azerty123")

  const goToLogin = () => {
    navigate("/Login")
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value)
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const userId = userCredential.user.uid;
        setUserId(userId)
        navigate("/Dashboard");
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ..
      });
  };
  return (
    <div className="flex h-5/6 items-center justify-center mx-auto">
      <form onSubmit={handleSubmit}>
        <div className="form-outline mb-4">
          <label className="form-label">Email address</label>
          <input type="email" id="form2Example1" className="form-control" value={email}
            onChange={handleEmailChange} />
        </div>
        <div className="form-outline mb-4">
          <label className="form-label">Password</label>
          <input type="password" id="form2Example2" className="form-control" value={password}
            onChange={handlePasswordChange} />
        </div>
        <div className="form-outline mb-4">
          <label className="form-label">Check Password</label>
          <input type="password" id="form2Example2" className="form-control" value={confirmPassword}
            onChange={handleConfirmPasswordChange} />
        </div>

        <div className="row mb-4">
          <div className="col d-flex justify-content-center">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" value="" id="form2Example31" />
              <label className="form-check-label"> Remember me </label>
            </div>
          </div>

          <div className="col">
            <a href="#!">Forgot password?</a>
          </div>
        </div>

        <button type="button" className="btn btn-primary btn-block mb-4 w-full" onClick={handleSubmit}>Register</button>

        <div className="text-center">
          <p>Already a user? <a className="text-primary" onClick={goToLogin}>Sign in</a></p>
        </div>
      </form>
    </div>
  );
};

export default Register;
